import { Body, IconButton } from '@assembly-js/design-system';
import { Menu, MenuItem } from '@material-ui/core';
import { useState } from 'react';

import { Action } from 'src/constants';
import { red } from 'src/theme/colors';

export const MenuAction = ({ actions }: { actions: Action[] }) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  return (
    <div>
      <IconButton
        size="sm"
        variant="minimal"
        icon="Ellipsis"
        onClick={(e) => setAnchorEl(e.currentTarget)}
        className="hover:bg-non-hover-border border-none"
      />
      <Menu
        classes={{
          paper: 'w-[160px]',
        }}
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        getContentAnchorEl={null}
      >
        {actions.map(({ key, name, onClick, icon, isDelete }) => (
          <MenuItem
            key={key}
            onClick={(e) => {
              onClick(e);
              setAnchorEl(null);
            }}
            className={'flex items-center gap-2 [&>svg]:w-3 [&>svg]:h-3'}
            style={{
              color: isDelete ? red : 'inherit',
            }}
          >
            {icon}
            <Body size="sm">{name}</Body>
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};
